<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <router-link class="crumb-home z-font-size-14" to="/icpMain">备案</router-link>
        </li>
        <li>
          <span class="z-font-size-14 z-color-999">备案审核查看 -</span>
          <router-link class="crumb-home z-font-size-14" :to="'/icpContent'+'/'+sessionFirstBeian.taskid">( 订单编号： <span class="z-colorblue">{{sessionFirstBeian.taskid}}</span> , 备案方式： <span class="z-colorblue">首次备案</span> , 当前状态： <span class="z-colorblue">准备任务</span> )</router-link>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">增加网站</div>
      </div>
      <div class="panel-body">
        <div class="alert-warn margin-bottom-20">
          请务必填写真实有效信息
        </div>
        <el-form v-if="sessionFirstBeian.taskid" :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="230px" class="beian-ruleForm">
          <el-form-item label="网站名称：" prop="web_name" :show-message="!formFocus.web_name">
            <el-input v-model="ruleForm.web_name" placeholder="请填写新增的网站名称" @focus="formFocus.web_name = true" @blur="formFocus.web_name = false"></el-input>
            <div class="icp-tip" v-show="formFocus.web_name">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                个人网站名称禁止使用人名地名、行业类以及经营性词汇
              </div>
            </div>
          </el-form-item>
          <el-form-item label="网站域名：" prop="domain" :show-message="!formFocus.domain">
            <el-input v-model="ruleForm.domain" @focus="formFocus.domain = true" @blur="formFocus.domain = false"></el-input>
            <div class="icp-tip" v-show="formFocus.domain">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                网站域名4-100个字符,不带www.，如：sanfengyun.com
              </div>
            </div>
            <p class="add-ym" v-if="!add.add1">
              <i class="add-icon1"></i>
              <a href="javascript:void(0);" class="add-yma" @click="add.add1 = true">继续添加域名</a>
            </p>
          </el-form-item>
          <el-form-item v-if="add.add1" label="网站域名：" prop="domain1" class="add-domain">
            <el-input v-model="ruleForm.domain1"></el-input>
            <a href="javascript:;" @click="add.add1 = false,ruleForm.domain1 = ''" class="del-a">删除</a>
            <p class="add-ym" v-if="!add.add2">
              <i class="add-icon1"></i>
              <a href="javascript:void(0);" class="add-yma" @click="add.add2 = true">继续添加域名</a>
            </p>
          </el-form-item>
          <el-form-item v-if="add.add2" label="网站域名：" prop="domain2" class="add-domain">
            <el-input v-model="ruleForm.domain2"></el-input>
            <a href="javascript:;" @click="add.add2 = false,ruleForm.domain2 = ''" class="del-a">删除</a>
            <p class="add-ym" v-if="!add.add3">
              <i class="add-icon1"></i>
              <a href="javascript:void(0);" class="add-yma" @click="add.add3 = true">继续添加域名</a>
            </p>
          </el-form-item>
          <el-form-item v-if="add.add3" label="网站域名：" prop="domain3" class="add-domain">
            <el-input v-model="ruleForm.domain3"></el-input>
            <a href="javascript:;" @click="add.add3 = false,ruleForm.domain3 = ''" class="del-a">删除</a>
            <p class="add-ym" v-if="!add.add4">
              <i class="add-icon1"></i>
              <a href="javascript:void(0);" class="add-yma" @click="add.add4 = true">继续添加域名</a>
            </p>
          </el-form-item>
          <el-form-item v-if="add.add4" label="网站域名：" prop="domain4" class="add-domain">
            <el-input v-model="ruleForm.domain4"></el-input>
            <a href="javascript:;" @click="add.add4 = false,ruleForm.domain4 = ''" class="del-a">删除</a>
          </el-form-item>
          <el-form-item label="网站首页网址：" prop="web_title" :show-message="!formFocus.web_title">
            <el-input v-model="ruleForm.web_title" style="width: 337px" @focus="formFocus.web_title = true" @blur="formFocus.web_title = false"></el-input>
            <div class="icp-tip" v-show="formFocus.web_title">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                网站首页须在4-255个字符以内,且网站首页网址必须包含域名中的一项
              </div>
            </div>
          </el-form-item>
          <el-form-item label="网站服务内容：" prop="web_content">
            {{ruleForm.web_content}}
          </el-form-item>
          <el-form-item label="语言类型：" prop="language">
            <el-select v-model="ruleForm.language" multiple placeholder="请选择" @focus="formFocus.language = true" @blur="formFocus.language = false">
              <el-option
                v-for="item in ruleForm.yylb"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="icp-tip" v-show="formFocus.language">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                建议选择中文简体
              </div>
            </div>
          </el-form-item>
          <el-form-item label="接入商信息：" prop="access_provider">
            {{ruleForm.access_provider}}
          </el-form-item>
          <!--<el-form-item label="网站接入方式：" prop="adsl">
            <el-radio-group v-model="ruleForm.adsl" v-for="(option, index) in ruleForm.wzjrfs" :key="index">
              <el-radio :label="Number(option.id)" class="z-margin-left-10-precent">{{option.mc}}</el-radio>
            </el-radio-group>
          </el-form-item>-->
          <el-form-item label="接入IP信息：" prop="ip" :show-message="!formFocus.ip">
            <el-input v-model="ruleForm.ip" placeholder="请您填写正确的IP信息"  @focus="formFocus.ip = true" @blur="formFocus.ip = false"></el-input>
            <div class="icp-tip" v-show="formFocus.ip">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请输入您的IP信息，多个IP用';'分割，如果IP信息为IP地址段，则起始IP和终止IP间用'-'分隔（如：111.67.0.100-111.67.0.102）。
              </div>
            </div>
          </el-form-item>
          <el-form-item label="前置或专项审批内容：" prop="examine">
            <!--<el-select v-model="ruleForm.examine" placeholder="请选择前置审批内容">
              <el-option
                v-for="item in ruleForm.qzsp"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>-->
            <div style="width: 374px" class="z-font-size-14">
              涉及
              <span v-for="option in ruleForm.qzsp" class="z-font-size-14">
              {{option.label}}、
              </span>
              请联系备案专员
            </div>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input type="textarea" v-model="ruleForm.remark"></el-input>
          </el-form-item>
          <div class="thread-fg5"></div>
          <p class="info-write">网站负责人信息填写 &gt;&gt;</p>
          <!--<el-form-item label="历史负责人：" prop="history_man">
            <el-select v-model="ruleForm.history_man" placeholder="&#45;&#45;选择历史负责人&#45;&#45;">
              <el-option
                v-for="item in ruleForm.lsfzr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>-->
          <el-form-item label="网站负责人姓名：" prop="boss_name" :show-message="!formFocus.boss_name">
            <el-input v-model="ruleForm.boss_name" placeholder="请填写正确的姓名" @focus="formFocus.boss_name = true" @blur="formFocus.boss_name = false"></el-input>
            <div class="icp-tip" v-show="formFocus.boss_name">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写网站负责人姓名
              </div>
            </div>
          </el-form-item>
          <el-form-item label="网站负责人证件类型：" prop="certificate">
            <el-select v-model="ruleForm.certificate" placeholder="--请选择--" @focus="formFocus.certificate = true" @blur="formFocus.certificate = false">
              <el-option
                v-for="item in ruleForm.zjlx"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="icp-tip" v-show="formFocus.certificate">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请选择您负责人证件类型!
              </div>
            </div>
          </el-form-item>
          <el-form-item label="网站负责人证件号码：" prop="number" :show-message="!formFocus.number">
            <el-input v-model="ruleForm.number" placeholder="请填写正确的网站负责人证件号码" @focus="formFocus.number = true" @blur="formFocus.number = false"></el-input>
            <div class="icp-tip" v-show="formFocus.number">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                填写的证件号码跟证件类型相对应！
              </div>
            </div>
          </el-form-item>
          <el-form-item label="网站负责人办公电话：" prop="tel">
            086-<el-input v-model="ruleForm.tel" placeholder="010-51661870" style="width: 337px" @focus="formFocus.tel = true" @blur="formFocus.tel = false"></el-input>
            <div class="icp-tip" v-show="formFocus.tel">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                格式：区号-号码，如：010-51661870
              </div>
            </div>
          </el-form-item>
          <el-form-item label="应急联系电话（手机）：" prop="emetel" :show-message="!formFocus.emetel">
            <el-input v-model="ruleForm.emetel" @focus="formFocus.emetel = true" @blur="formFocus.emetel = false"></el-input>
            <div class="icp-tip" v-show="formFocus.emetel">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写有效的手机号码
              </div>
            </div>
          </el-form-item>
          <el-form-item label="网站负责人电子邮箱：" prop="email" :show-message="!formFocus.email">
            <el-input v-model="ruleForm.email" placeholder="请填写电子邮箱" @focus="formFocus.email = true" @blur="formFocus.email = false"></el-input>
            <div class="icp-tip" v-show="formFocus.email">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请正确填写负责人电子邮箱
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="z-display-inlineBlock z-lineHeight-20">
              <xbutton font="下一步" type="orange" @XbuttonService="submitForm('ruleForm')"/>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import XfromInput from 'commons/XfromInput.vue'
  import XbeianCity from 'commons/XbeianCity.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import beianService from 'business/beianService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  export default {
    data() {
      return {
        dialogLoading:false,
        sessionFirstBeian:{},
        listLoading:false,
        labelPosition: 'right',
        DISTRICTS:[],
        cityInfo: {
          province:'北京市',
          city:'市辖区',
          area:'东城区'
        },
        cityId:{
          provinceid: 0,
          cityid: 1,
          districtid: 1
        },
        ruleForm: {
          beian_number:'',
          zt_password:'',
          web_name:'',
          domain:'',
          domain1:'',
          domain2:'',
          domain3:'',
          domain4:'',
          web_title:'',
          web_content:'其他',
          language:'',
          access_provider:'三丰云',
          adsl:1,
          wzjrfs:[],
          ip:'',
          examine:'',
          qzsp:[],
          remark:'',
          history_man:'',
          lsfzr:[],
          boss_name:'',
          certificate: '',
          zjlx:[],
          number:'',
          tel:'',
          emetel:'',
          email:''
        },
        rules: {
          beian_number: [
            { required: true, message: '请正确填写您的备案号', trigger: 'blur' }
          ],
          zt_password: [
            { required: true, message: '主体密码90个字符以内', trigger: 'blur' }
          ],
          web_name: [
            { required: true, message: '网站名称1-90个字符，不能含有任何特殊字符', trigger: 'blur' }
          ],
          domain: [
            { required: true, message: '网站域名4-100个字符', trigger: 'blur' }
          ],
          domain1: [
            { required: true, message: '请正确填写您的网站域名！', trigger: 'blur' },
            { validator: async function (rule, value, callback) {
                let data = 'cmd=check_domain'+'&domain='+value
                let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
                if(vueData.response == 200){
                  callback()
                }else{
                  callback(new Error(vueData.msg))
                }
              },trigger: 'blur'}
          ],
          domain2: [
            { required: true, message: '请正确填写您的网站域名！', trigger: 'blur' },
            { validator: async function (rule, value, callback) {
                let data = 'cmd=check_domain'+'&domain='+value
                let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
                if(vueData.response == 200){
                  callback()
                }else{
                  callback(new Error(vueData.msg))
                }
              },trigger: 'blur'}
          ],
          domain3: [
            { required: true, message: '请正确填写您的网站域名！', trigger: 'blur' },
            { validator: async function (rule, value, callback) {
                let data = 'cmd=check_domain'+'&domain='+value
                let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
                if(vueData.response == 200){
                  callback()
                }else{
                  callback(new Error(vueData.msg))
                }
              },trigger: 'blur'}
          ],
          domain4: [
            { required: true, message: '请正确填写您的网站域名！', trigger: 'blur' },
            { validator: async function (rule, value, callback) {
                let data = 'cmd=check_domain'+'&domain='+value
                let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
                if(vueData.response == 200){
                  callback()
                }else{
                  callback(new Error(vueData.msg))
                }
              },trigger: 'blur'}
          ],
          web_title: [
            { required: true, message: '网站首页网址必须包含域名中的一项', trigger: 'blur' }
          ],
          language: [
            { required: true, message: '请选择语言类型！', trigger: 'change' }
          ],
          ip: [
            { required: true, message: '请输入您的IP信息，多个IP用;分割，如果IP信息为IP地址段，则起始IP和终止IP间用-分隔（如：111.67.0.100-111.67.0.102）。', trigger: 'blur' }
          ],
          boss_name: [
            { required: true, message: '负责人姓名2-45个字符', trigger: 'blur' }
          ],
          certificate: [
            { required: true, message: '请选择您负责人证件类型!', trigger: 'change' }
          ],
          number: [
            { required: true, message: '有效证件号1-50个字符', trigger: 'blur' },
          ],
          emetel: [
            { required: true, message: '请输入正确的应急联系电话！', trigger: 'blur' },
          ],
          email: [
            { required: true, message: '邮箱格式不正确或长度超过45位', trigger: 'blur' }
          ],

        },
        domainMsg:'',
        captcha:'https://api.sanfengyun.com/www/yzm.php?rnd='+Math.random(),
        add:{
          add1:false,
          add2:false,
          add3:false,
          add4:false,
        },
        formFocus: {
          beian_number:false,
          zt_password:false,
          web_name:false,
          domain:false,
          web_title:false,
          language:false,
          ip:false,
          boss_name:false,
          certificate: false,
          number:false,
          address:false,
          commun:false,
          investor:false,
          tel:false,
          emetel:false,
          email:false
        }
      };
    },
    props:{
      hide:Boolean
    },
    components: {
      XdialogLoading,
      XfromInput,
      Xbutton,
      XbeianCity
    },
    mounted() {
      this.sessionFirstBeian = sessionStorage.getItem('firstbeian') ? JSON.parse(sessionStorage.getItem('firstbeian')) : {}
      this.sessionBeian = sessionStorage.getItem('beian') ? JSON.parse(sessionStorage.getItem('beian')) : {}
      this.beianInfo()
    },
    computed: {
      certificate() {
        return this.ruleForm.certificate
      },
      domain() {
        return this.ruleForm.domain
      }
    },
    watch:{
      certificate(newValue,oldValue){
        if(newValue == 2){
          this.rules.number.push({ validator: function (rule, value, callback) {
              let idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
              if (!idCardRegex.test(value)) {
                callback(new Error('请输入有效的18位身份证号！'))
              } else {
                callback();
              }
            },trigger: 'blur'})
        }else{
          if(oldValue == 2){
            this.rules.number.pop()
          }
        }
      },
      domain(newValue){
        this.ruleForm.web_title = 'www.'+newValue
      }
    },
    methods:{
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      async beianInfo() {
        this.listLoading = true
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST','cmd=get_dm')
        if(state.code === '000' ) {
          this.listLoading = false
          this.DISTRICTS = vueData.qy
          this.zjlxArr = vueData.zjlx.map((item, index) => {
            return {
              value: item.id,
              label: item.mc,
              dwflid: item.dwflid
            }
          })
          this.ruleForm.zjlx = [...this.zjlxArr.filter(item => item.dwflid == 5)]
          this.ruleForm.yylb = vueData.yylb.map((item, index) => {
            return {
              value: item.id,
              label: item.mc,
            }
          })
          this.ruleForm.qzsp = vueData.wzjylx.map((item, index) => {
            return {
              value: item.id,
              label: item.mc,
            }
          })
          this.ruleForm.wzjrfs = vueData.wzjrfs
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async submit() {
        this.dialogLoading = true
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].mc == this.cityInfo.province){
            this.cityId.provinceid = Number(this.DISTRICTS[i].id)
            let province = this.DISTRICTS[i].shi
            for(let j in province){
              if(province[j].mc == this.cityInfo.city){
                this.cityId.cityid=Number(province[j].id)
                let city = province[j].xian
                for(let k in city){
                  if(city[k].mc == this.cityInfo.area){
                    this.cityId.districtid=Number(city[k].id)
                  }
                }
              }
            }
          }
        }
        let ym1 = (this.ruleForm.domain1 != '') ? this.ruleForm.domain.concat(",",this.ruleForm.domain1) : this.ruleForm.domain
        let ym2 = (this.ruleForm.domain2 != '') ? ym1.concat(",",this.ruleForm.domain2) : ym1
        let ym3 = (this.ruleForm.domain3 != '') ? ym2.concat(",",this.ruleForm.domain3) : ym2
        let ym = (this.ruleForm.domain4 != '') ? ym3.concat(",",this.ruleForm.domain4) : ym3
        console.log(this.sessionBeian)
        let data = 'cmd=wangzhan_edit'
          +'&cmd_type=add'
          +'&ztxtid='+ this.sessionFirstBeian.ztxtid
          +'&ba_path='+ this.sessionFirstBeian.beian_path
          +'&wzmc=' + this.ruleForm.web_name
          +'&ym=' + ym
          +'&syurl=' + this.ruleForm.web_title
          +'&yylb_id=' + this.ruleForm.language
          +'&fzr_xm=' + this.ruleForm.boss_name
          +'&fzr_zjlx=' + this.ruleForm.certificate
          +'&fzr_zjhm=' + this.ruleForm.number
          +'&fzr_sjhm=' + this.ruleForm.emetel
          +'&fzr_dzyj=' + this.ruleForm.email
          +'&wz_bz=' + this.ruleForm.remark
          +'&fzr_dhhm=' + this.ruleForm.tel
          +'&ip=' + this.ruleForm.ip
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200){
          this.dialogLoading = false
          let self = this
          this.$dialog({
            type:'success',
            info: vueData.msg,
            click () {
              sessionStorage.setItem('tabs','second')
              self.$router.push('/icpContent/'+ self.sessionFirstBeian.taskid)
            }
          })
        }else{
          this.dialogLoading = false
          this.$dialog({
            type:'error',
            info: vueData.msg,
            click () {}
          })
        }
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .alert-warn {
    margin-bottom: 30px;
  }
  .breadcrumb li:last-child a {
    color: #999;
  }
  .z-colorblue{
    color: #009FD9;
    font-size: 14px;
  }
  .beian-ruleForm .el-input,.el-select,.el-textarea {
    width: 374px;
  }
  .thread-fg5 {
    width: 100%;
    border-bottom: 1px dashed #cecece;
    margin: 52px 0 0 0;
  }
  .add-ym {
    overflow: hidden;
    width: 100%;
  }
  .add-icon1 {
    width: 14px;
    height: 14px;
    background: url(../../assets/imgs/20161129img4.png) no-repeat;
    display: block;
    margin-top: 9px;
    margin-right: 6px;
    cursor: pointer;
    float: left;
  }
  .add-yma {
    font-size: 12px;
    color: #4074e1;
    text-decoration: underline;
    float: left;
  }
  .del-a {
    color: #009de0;
    margin-left: 16px;
    text-decoration: underline;
    display: inline-block;
    vertical-align: 1px;
  }
  .icp-msg {
    color: #4074e1;
    border: solid 1px #4074e1;
    background: #ecf1fc;
    border-radius: 3px;
    position: relative;
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px;
    padding: 10px;
    width: 352px;
  }
  em{
    font-style: normal;
    font-weight: 500;
  }
  .icp-tip {
    position: absolute;
    left: 375px;
    top: 0;
    margin-left: 10px;
    width: 400px;
    line-height: 32px;
    font-size: 12px;
  }
  .icp-tip .icp-msg {
    margin: 0 0 0 30px;
    padding: 6px 10px;
    width: 300px;
  }
  .icp-tip span {
    padding-left: 26px;
  }
  .hoticon-left {
    position: absolute;
    top: 12px;
    left: -4px;
    background: url(../../assets/imgs/hoticon.png) no-repeat;
    background-position: 0 -5px;
    width: 4px;
    height: 6px;
  }
  .icon-i {
    color: #4074e1;
    padding-left: 5px;
  }
  .info-write {
    font-size: 20px;
    color: #333;
    line-height: 84px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/beian/beian9.vue